import { render } from "./order-status-content.vue?vue&type=template&id=36705c7a&scoped=true"
import script from "./order-status-content.vue?vue&type=script&lang=js"
export * from "./order-status-content.vue?vue&type=script&lang=js"

import "./order-status-content.vue?vue&type=style&index=0&id=36705c7a&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36705c7a"]])

export default __exports__